export type SearchBarProps = {
  value: string
  onChange?: (value: string) => void
}

export function SearchBar (props: SearchBarProps) {
  const { value, onChange } = props

  return (
    <div className="px-6 md:px-0 mx-auto container">
      <label className="input manrope-regular w-full my-4">
        <svg className="h-[1em] opacity-50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g strokeLinejoin="round" strokeLinecap="round" strokeWidth="2.5" fill="none" stroke="currentColor"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></g></svg>
        <input
          type="search"
          className="grow"
          placeholder="Search templates"
          value={value}
          onChange={e => onChange?.(e.target.value)}
        />
      </label>
    </div>
  )
}
